import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { ITitleWithHintProps } from './models';

export const TitleWithHint: FC<ITitleWithHintProps> = ({
    ArrowPopover,
    IconHint,
    children,
    hint,
    styles,
}) => {
    return (
        <div className={styles.wrapper}>
            {children}
            <ArrowPopover content={hint}>
                <IconHint className={cn(styles.external, styles.hint)} height="16px" width="16px" />
            </ArrowPopover>
        </div>
    );
};
